import { render, staticRenderFns } from "./product-browse.vue?vue&type=template&id=1e8ccbb9&scoped=true&"
import script from "./product-browse.vue?vue&type=script&lang=js&"
export * from "./product-browse.vue?vue&type=script&lang=js&"
import style0 from "./product-browse.vue?vue&type=style&index=0&id=1e8ccbb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8ccbb9",
  null
  
)

export default component.exports